module.exports = __webpack_public_path__ + "img/legende175.df05ba2d.jpg";